<template>
  <v-form @submit.prevent="save" enctype="multipart/form-data">
      <v-container py-0>
            <v-layout wrap>
                <v-flex xs12 md4 class="text-xs-center">
                  <label>{{$t('Pages.Users.model.avatar')}}</label>
                  <vue-avatar :width="150" :height="150" id="avatar" ref="avatar" v-if="user.id || !edit" :image="user.profile.avatar">

                  </vue-avatar>

                  <v-tooltip top>
                    <v-btn @click="openAvatarDialog" slot="activator" fab dark color="primary">
                      <v-icon dark>camera</v-icon>
                    </v-btn>
                    <span>{{$t('Common.click_to_select_image')}}</span>
                  </v-tooltip>
                </v-flex>

                <v-flex xs12 md7 class="text-xs-center">
                  <label>{{$t('Pages.Users.model.signature')}}</label>
                  <vue-avatar :width="450" :height="150" id="signature" ref="signature" v-if="user.id || !edit" :image="user.profile.signature">
                  </vue-avatar>

                  <v-tooltip top>
                    <v-btn @click="openSignatureDialog" slot="activator" fab dark color="success">
                      <v-icon dark>camera</v-icon>
                    </v-btn>
                    <span>{{$t('Common.click_to_select_image')}}</span>
                  </v-tooltip>
                </v-flex>

                <v-flex xs12 md4>
                  <v-text-field
                          v-validate="'required'"
                          v-model="user.profile.name"
                          :error-messages="errors.first('name')"
                          :label="$t('Pages.Users.model.name')"
                          type="text"
                          color="indigo"
                          required
                          name="name"
                  />
                </v-flex>

                <v-flex xs12 md4>
                    <v-select
                            :items="genders"
                            v-validate="'required'"
                            v-model="user.profile.gender"
                            :error-messages="errors.first('genders')"
                            :label="$t('Pages.Users.model.gender')"
                            required
                            name="genders"
                            color="indigo"
                            clearable
                            item-text="name"
                            item-value="key"
                    ></v-select>
                </v-flex>
                <v-flex  xs12 md4>
                  <v-text-field
                          v-validate="'email'"
                          v-model="user.email"
                          :error-messages="errors.first('email')"
                          :label="$t('Pages.Users.model.email')"
                          type="email"
                          color="indigo"
                          required
                          name="email"
                  />
                </v-flex>
                <v-flex xs12 md4>
                    <v-text-field
                            v-model="user.profile.address"
                            :error-messages="errors.first('address')"
                            :label="$t('Pages.Users.model.address')"
                            type="text"
                            color="indigo"
                            name="address"
                    />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                          v-model="user.barcode"
                          :error-messages="errors.first('barcode')"
                          :label="$t('Pages.Users.model.barcode')"
                          type="text"
                          color="indigo"
                          min="0"
                          name="barcode"
                  />
                </v-flex>
                <v-flex xs12 md4>
                    <v-dialog
                            ref="dialogWorking"
                            v-model="modalWorking"
                            :return-value.sync="user.profile.started_working"
                            persistent
                            lazy
                            full-width
                            width="290px"
                    >
                        <v-text-field
                                slot="activator"
                                v-model="computedStartWorking"
                                :label="$t('Pages.Users.model.started_working')"
                                prepend-icon="event"
                                readonly
                                color="indigo"
                                name="started_working"
                                :error-messages="errors.first('started_working')"
                        ></v-text-field>
                        <v-date-picker locale="sr-Latn-RS" color="indigo" v-model="user.profile.started_working" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="modalWorking = false">{{$t('Core.Fields.cancel')}}</v-btn>
                            <v-btn flat color="indigo" @click="$refs.dialogWorking.save(user.profile.started_working)">{{$t('Core.Fields.ok')}}</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex xs12 md4>
                    <v-text-field
                            v-model="user.profile.phone"
                            :error-messages="errors.first('phone')"
                            :label="$t('Pages.Users.model.phone')"
                            type="text"
                            color="indigo"
                            name="phone"
                    />
                </v-flex>
                <v-flex xs12 md4>
                    <v-text-field
                            v-model="user.profile.contract"
                            :error-messages="errors.first('contract')"
                            :label="$t('Pages.Users.model.contract')"
                            type="text"
                            color="indigo"
                            min="0"
                            name="contract"
                    />
                </v-flex>
                <v-flex xs12 md4>
                    <v-dialog
                            ref="dialog"
                            v-model="modal"
                            :return-value.sync="user.profile.birthday"
                            persistent
                            lazy
                            full-width
                            width="290px"
                    >
                        <v-text-field
                                slot="activator"
                                v-model="computedBirthday"
                                :label="$t('Pages.Users.model.birthday')"
                                prepend-icon="cake"
                                readonly
                                color="indigo"
                                name="birthday"
                                :error-messages="errors.first('birthday')"
                        ></v-text-field>
                        <v-date-picker locale="sr-Latn-RS" color="indigo" v-model="user.profile.birthday" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
                            <v-btn flat color="indigo" @click="$refs.dialog.save(user.profile.birthday)">{{$t('Core.Fields.ok')}}</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex  xs12 md4>
                    <v-text-field
                            v-model="user.jmbg"
                            :error-messages="errors.first('jmbg')"
                            :label="$t('Pages.Users.model.jmbg')"
                            type="number"
                            color="indigo"
                            name="jmbg"
                    />
                </v-flex>
                <v-flex xs12 md4>
                    <v-select
                            :items="yesNo"
                            v-validate="'required'"
                            v-model="user.profile.is_agency"
                            :error-messages="errors.first('yesNo')"
                            :label="$t('Pages.Users.model.agency')"
                            required
                            name="yesNo"
                            color="indigo"
                            clearable
                            item-text="name"
                            item-value="key"
                    ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                    <v-dialog
                            ref="dialogPatron"
                            v-model="modalPatron"
                            :return-value.sync="user.profile.patron_saint"
                            persistent
                            lazy
                            full-width
                            width="290px"
                    >
                        <v-text-field
                                slot="activator"
                                v-model="computedPatron"
                                :label="$t('Pages.Users.model.patron_saint')"
                                prepend-icon="mdi-christianity"
                                readonly
                                color="indigo"
                                name="birthday"
                                :error-messages="errors.first('patron_saint')"
                        ></v-text-field>
                        <v-date-picker locale="sr-Latn-RS" color="indigo" v-model="user.profile.patron_saint" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="modalPatron = false">{{$t('Core.Fields.cancel')}}</v-btn>
                            <v-btn flat color="indigo" @click="$refs.dialogPatron.save(user.profile.patron_saint)">{{$t('Core.Fields.ok')}}</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <v-flex  xs12 md4>
                    <v-text-field
                            slot="activator"
                            v-model="user.profile.driving_card_number"
                            :label="$t('Pages.Users.model.driving_card_number')"
                            type="text"
                            color="indigo"
                            name="driving_card_number"
                            :error-messages="errors.first('driving_card_number')"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                          :items="roles"
                          multiple
                          v-validate="'required'"
                          v-model="user.roles"
                          :error-messages="errors.first('roles')"
                          :label="$t('Pages.Users.model.role')"
                          required
                          name="roles"
                          color="indigo"
                          clearable
                          item-text="name"
                          item-value="id"
                          return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4 v-if="showPassword">
                  <v-text-field
                          v-validate="!edit ? 'required|min:6' : ''"
                          v-model="user.password"
                          :error-messages="errors.first('password')"
                          :label="$t('Core.Fields.password')"
                          type="password"
                          color="indigo"
                          required
                          counter
                          name="password"
                  />
                </v-flex>
                <v-flex xs12 md4 v-if="showPassword">
                  <v-text-field
                          v-validate="!edit ? 'required|min:6' : ''"
                          v-model="user.password_confirmation"
                          :error-messages="errors.first('password_confirmation')"
                          :label="$t('Core.Fields.confirm_new_password')"
                          type="password"
                          required
                          name="password_confirmation"
                          counter
                  />
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-btn round color="indigo" dark type="submit">
                  {{$t('Core.Fields.save')}}
                </v-btn>
                <v-btn round href="javascript:history.go(-1)">
                  {{$t('Core.Fields.back')}}
                </v-btn>
            </v-layout>
      </v-container>
  </v-form>
</template>

<script>
    import Form from '../../services/Form'
    import VueAvatar from '../../components/core/VueAvatar'
    import _ from 'lodash';
export default {
  components: {VueAvatar},
  props: {
      user: {
          type: Object,
          required: true
      },
      edit: {
          type: Boolean,
          default: false
      }
  },
  data: () => ({
    roles: [],
    modal: false,
    modalWorking: false,
    modalPatron: false,
    genders: [],
    yesNo: []
  }),
  computed: {
      computedStartWorking(val){
          return this.getLocaleDateFormat(this.user.profile.started_working);
      },
      computedBirthday(val){
          return this.getLocaleDateFormat(this.user.profile.birthday);
      },
      computedPatron(val){
          return this.getLocaleDateFormat(this.user.profile.patron_saint);
      },
    showPassword: function () {
        if(!this.user.roles || this.user.hasPassword){
            return false;
        }
        let self = this;
        let result = false;
        this.user.roles.forEach((item) => {
          if(item.name != self.UserRoles.USER){
              result = true;
          }
        });

        return result;
    }
  },
  created () {
      this.getRoles();
      this.genders = [
          {
              key: this.UserGenders.MALE,
              name: this.$t('UserGenders.male')
          },
          {
              key: this.UserGenders.FEMALE,
              name: this.$t('UserGenders.female')
          },
      ];

        this.yesNo = [
            {
                key: 1,
                name: this.$t('Common.yes')
            },
            {
                key: 0,
                name: this.$t('Common.no')
            },
        ];
  },
  methods: {
      openAvatarDialog(){
          this.$refs.avatar.clicked();
      },
      openSignatureDialog(){
          this.$refs.signature.clicked();
      },
      getRoles(){
          this.repositories.role.all().then((response) => {
            this.roles = response.data.data;
          }).finally(() => {
          });
      },
      save(){
        this.$validator.validateAll().then((result) => {
              if (result) {
                  let data = JSON.parse(JSON.stringify(this.user));
                  data.roles = _.map(this.user.roles, 'id');

                  data['profile'].avatar = null;
                  if(this.$refs.avatar.imageChanged()) {
                      data['profile'].avatar = this.$refs.avatar.getImage();
                  }

                  data['profile'].signature = null;

                  if(this.$refs.signature.imageChanged()) {
                      data['profile'].signature = this.$refs.signature.getImage();
                  }

                  this.$emit('save', data);
              }
          });
      }
  }
}
</script>

<style lang="scss">

</style>
